import tabs from '../slices/tabs';
import type { RootStateType } from '../index';

export const {
    setActiveTab
} = tabs.actions;

export const selectActiveTab = (activeTabKey: string) => (state: RootStateType) => state.tabs.activeTab[activeTabKey];
